import axios from 'axios';

// Embedded, AO runs in the shell's document, so a relative API path would resolve against the shell's origin.
// We can make sure to get the right path if we look at axios's baseURL,
// which would have been set in embedded mode, empty otherwise.
export const toApiUrl = path =>
  path?.startsWith('/') ? `${axios.defaults.baseURL ?? ''}${path}` : path;

export default { toApiUrl };
